import React, { useState } from "react";
import CustomSelectBasic from "../../../components/common/CustomSelect/CustomSelectBasic";
import { AlertCircle } from "lucide-react";
import styles from "./LeadAssignmentTab.module.css";

const LeadAssignmentTab = () => {
  const [autoAssign, setAutoAssign] = useState(false);
  const [manualAssign, setManualAssign] = useState(false);
  const [autoAssignTemplate, setAutoAssignTemplate] = useState("");
  const [manualAssignTemplate, setManualAssignTemplate] = useState("");
  const [autoAssignError, setAutoAssignError] = useState(false);

  // Mock template options - replace with actual data
  const templateOptions = [
    { label: "Template 1", value: "template1" },
    { label: "Template 2", value: "template2" },
    { label: "Template 3", value: "template3" },
  ];

  const handleAutoAssignChange = () => {
    setAutoAssign(!autoAssign);
    if (!autoAssign) {
      // Simulating auto-assignment failure
      setAutoAssignError(true);
    } else {
      setAutoAssignError(false);
    }
  };

  const handleManualAssignChange = () => {
    setManualAssign(!manualAssign);
  };

  return (
    <div className={styles.container}>
      {/* Auto-Assign Section */}
      <div className={styles.card}>
      <div className="p-6">
        <div className={styles.cardHeader}>
          <div>
            <h3 className={styles.cardTitle}>Auto-Assign Leads</h3>
            <p className={styles.cardDescription}>Auto-assigned to the company's Relationship Manager.</p>
          </div>
          <div className="flex items-center gap-4">
            <button
              onClick={handleAutoAssignChange}
              className={`w-12 h-6 rounded-full p-1 transition-colors duration-200 ease-in-out ${
                autoAssign ? "bg-blue-500" : "bg-gray-300"
              }`}
            >
              <div
                className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-200 ease-in-out ${
                  autoAssign ? "translate-x-6" : "translate-x-0"
                }`}
              />
            </button>
            {autoAssign && (
              <div className="w-[200px]">
                <CustomSelectBasic
                  name="autoAssignTemplate"
                  value={autoAssignTemplate}
                  menuList={templateOptions}
                  onChange={(e) => setAutoAssignTemplate(e.target.value)}
                  placeholder="Select a template"
                />
              </div>
            )}
          </div>
        </div>

        {autoAssignError && (
          <div className={styles.errorMessage}>
            <AlertCircle className="w-5 h-5" />
            <p className="text-sm">
              Auto-assignment failed: No Relationship Manager matched the product or availability. Lead can be assigned manually.
            </p>
          </div>
        )}
      </div>

      {/* Manual-Assign Section */}
      <div className="p-6 border-t border-b">
        <div className={styles.cardHeader}>
          <div>
            <h3 className={styles.cardTitle}>Manual-Assign Leads</h3>
            <p className={styles.cardDescription}>Manual-assigned to the company's Relationship Manager.</p>
          </div>
          <div className="flex items-center gap-4">
            <button
              onClick={handleManualAssignChange}
              className={`w-12 h-6 rounded-full p-1 transition-colors duration-200 ease-in-out ${
                manualAssign ? "bg-blue-500" : "bg-gray-300"
              }`}
            >
              <div
                className={`bg-white w-4 h-4 rounded-full shadow-md transform duration-200 ease-in-out ${
                  manualAssign ? "translate-x-6" : "translate-x-0"
                }`}
              />
            </button>
            {manualAssign && (
              <div className="w-[200px]">
                <CustomSelectBasic
                  name="manualAssignTemplate"
                  value={manualAssignTemplate}
                  menuList={templateOptions}
                  onChange={(e) => setManualAssignTemplate(e.target.value)}
                  placeholder="Select a template"
                />
              </div>
            )}
          </div>
        </div>
      </div>
    </div>
    </div>
  );
};

export default LeadAssignmentTab; 